(function () {
  'use strict';

  // ---------- Pure pricing & validation (unit-tested) ----------
  function bundleSlotCount(tier) {
    return (tier.oz32Slots || 0) + (tier.gallonSlots || 0);
  }

  function filledSelections(selection) {
    var oz = (selection.oz32 || []).filter(Boolean);
    var gal = (selection.gallon || []).filter(Boolean);
    return oz.concat(gal);
  }

  function isBundleComplete(tier, selection) {
    var oz = (selection.oz32 || []).filter(Boolean).length;
    var gal = (selection.gallon || []).filter(Boolean).length;
    return oz === tier.oz32Slots && gal === tier.gallonSlots;
  }

  function bundleSubtotalCents(selection) {
    return filledSelections(selection).reduce(function (sum, item) {
      return sum + (item.priceCents || 0);
    }, 0);
  }

  function bundleDiscountCents(tier, subtotalCents) {
    return Math.round(subtotalCents * (tier.discount || 0) / 100);
  }

  function bundleTotalCents(tier, subtotalCents) {
    return subtotalCents - bundleDiscountCents(tier, subtotalCents);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Export pure functions for Node tests.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      bundleSlotCount: bundleSlotCount,
      filledSelections: filledSelections,
      isBundleComplete: isBundleComplete,
      bundleSubtotalCents: bundleSubtotalCents,
      bundleDiscountCents: bundleDiscountCents,
      bundleTotalCents: bundleTotalCents,
      formatMoney: formatMoney
    };
  }

  // ---------- DOM controller (browser only) ----------
  if (typeof document === 'undefined') { return; }

  function parseJSON(el, fallback) {
    if (!el) { return fallback; }
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function makeBundleId() {
    return 'bb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function initSection(root) {
    var products = parseJSON(root.querySelector('[data-acg-bb-products]'), []);
    var tiers = parseJSON(root.querySelector('[data-acg-bb-tiers]'), []);

    var els = {
      tierButtons: root.querySelectorAll('[data-acg-bb-tier]'),
      builder: root.querySelector('[data-acg-bb-builder]'),
      summary: root.querySelector('[data-acg-bb-summary]'),
      picker: root.querySelector('[data-acg-bb-picker]'),
      pickerTitle: root.querySelector('[data-acg-bb-picker-title]'),
      pickerGrid: root.querySelector('[data-acg-bb-picker-grid]')
    };

    var state = { tier: null, selection: { oz32: [], gallon: [] }, activeSize: null, activeIndex: null };

    function tierById(id) {
      for (var i = 0; i < tiers.length; i++) { if (tiers[i].id === id) { return tiers[i]; } }
      return null;
    }

    function resizeSelection(arr, len) {
      var next = [];
      for (var i = 0; i < len; i++) { next.push(arr[i] || null); }
      return next;
    }

    function selectTier(tierId) {
      var tier = tierById(tierId);
      if (!tier) { return; }
      state.tier = tier;
      // Preserve already-picked products up to the new slot counts.
      state.selection = {
        oz32: resizeSelection(state.selection.oz32 || [], tier.oz32Slots),
        gallon: resizeSelection(state.selection.gallon || [], tier.gallonSlots)
      };
      Array.prototype.forEach.call(els.tierButtons, function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-acg-bb-tier') === tierId);
      });
      renderBuilder();
      renderSummary();
      els.builder.hidden = false;
      els.summary.hidden = false;
    }

    function slotMarkup(sizeKey, index) {
      var picked = state.selection[sizeKey][index];
      var label = sizeKey === 'oz32' ? '32oz' : 'Gallon';
      if (picked) {
        return '<button type="button" class="acg-bb__slot is-filled" data-acg-bb-slot data-size="' + sizeKey + '" data-index="' + index + '">' +
          (picked.image ? '<img class="acg-bb__slot-img" src="' + esc(picked.image) + '" alt="">' : '') +
          '<span class="acg-bb__slot-title">' + esc(picked.title) + '</span>' +
          '<span class="acg-bb__slot-change">Change</span>' +
          '</button>';
      }
      return '<button type="button" class="acg-bb__slot" data-acg-bb-slot data-size="' + sizeKey + '" data-index="' + index + '">' +
        '<span class="acg-bb__slot-plus">+</span>' +
        '<span class="acg-bb__slot-label">Choose ' + label + '</span>' +
        '</button>';
    }

    function groupMarkup(sizeKey, count, heading) {
      if (count <= 0) { return ''; }
      var slots = '';
      for (var i = 0; i < count; i++) { slots += slotMarkup(sizeKey, i); }
      return '<div class="acg-bb__group"><h3 class="acg-bb__group-head">' + heading + '</h3>' +
        '<div class="acg-bb__slots">' + slots + '</div></div>';
    }

    function renderBuilder() {
      var t = state.tier;
      els.builder.innerHTML =
        '<h2 class="acg-bb__builder-head">Build your ' + t.name + '</h2>' +
        groupMarkup('oz32', t.oz32Slots, '32oz — pick ' + t.oz32Slots) +
        groupMarkup('gallon', t.gallonSlots, '1 Gallon — pick ' + t.gallonSlots);
    }

    function renderSummary() {
      var t = state.tier;
      var subtotal = bundleSubtotalCents(state.selection);
      var discount = bundleDiscountCents(t, subtotal);
      var total = bundleTotalCents(t, subtotal);
      var filled = filledSelections(state.selection).length;
      var slots = bundleSlotCount(t);
      var complete = isBundleComplete(t, state.selection);
      els.summary.innerHTML =
        '<h3 class="acg-bb__summary-head">' + t.name + '</h3>' +
        '<p class="acg-bb__summary-progress">' + filled + ' of ' + slots + ' slots filled</p>' +
        '<dl class="acg-bb__summary-lines">' +
          '<div><dt>Subtotal</dt><dd>' + formatMoney(subtotal) + '</dd></div>' +
          '<div class="acg-bb__summary-discount"><dt>Discount (' + t.discount + '%)</dt><dd>−' + formatMoney(discount) + '</dd></div>' +
          '<div class="acg-bb__summary-total"><dt>Bundle price</dt><dd>' + formatMoney(total) + '</dd></div>' +
        '</dl>' +
        '<button type="button" class="acg-bb__add" data-acg-bb-add ' + (complete ? '' : 'disabled') + '>' +
          (complete ? 'Add bundle to cart' : 'Fill all slots to continue') +
        '</button>' +
        '<p class="acg-bb__add-status" data-acg-bb-status role="status" aria-live="polite"></p>';
    }

    function openPicker(sizeKey, index) {
      state.activeSize = sizeKey;
      state.activeIndex = index;
      els.pickerTitle.textContent = 'Choose a ' + (sizeKey === 'oz32' ? '32oz' : 'Gallon') + ' product';
      var html = '';
      products.forEach(function (p) {
        var sz = p.sizes[sizeKey];
        if (!sz) { return; }
        var disabled = !sz.available;
        html += '<button type="button" class="acg-bb__pick' + (disabled ? ' is-disabled' : '') + '"' +
          (disabled ? ' disabled' : '') +
          ' data-acg-bb-pick data-handle="' + esc(p.handle) + '">' +
          (p.image ? '<img class="acg-bb__pick-img" src="' + esc(p.image) + '" alt="">' : '') +
          '<span class="acg-bb__pick-title">' + esc(p.title) + '</span>' +
          '<span class="acg-bb__pick-price">' + formatMoney(sz.priceCents) + '</span>' +
          (disabled ? '<span class="acg-bb__pick-oos">Sold out</span>' : '') +
          '</button>';
      });
      els.pickerGrid.innerHTML = html;
      state.lastFocus = document.activeElement;
      els.picker.hidden = false;
      var closeBtn = els.picker.querySelector('[data-acg-bb-picker-close]');
      if (closeBtn) { closeBtn.focus(); }
    }

    function closePicker() {
      els.picker.hidden = true;
      state.activeSize = null;
      state.activeIndex = null;
      if (state.lastFocus && state.lastFocus.focus) { state.lastFocus.focus(); }
    }

    function choose(handle) {
      var product = null;
      for (var i = 0; i < products.length; i++) { if (products[i].handle === handle) { product = products[i]; break; } }
      if (!product) { return; }
      var sz = product.sizes[state.activeSize];
      if (!sz || !sz.available) { return; }
      state.selection[state.activeSize][state.activeIndex] = {
        variantId: sz.variantId, priceCents: sz.priceCents, title: product.title, image: product.image
      };
      closePicker();
      renderBuilder();
      renderSummary();
    }

    function addBundle() {
      var status = root.querySelector('[data-acg-bb-status]');
      var addBtn = root.querySelector('[data-acg-bb-add]');
      if (!isBundleComplete(state.tier, state.selection)) { return; }
      var bundleId = makeBundleId();
      var items = [];
      [['oz32', '32oz'], ['gallon', 'gallon']].forEach(function (pair) {
        var sizeKey = pair[0], sizeLabel = pair[1];
        state.selection[sizeKey].forEach(function (s) {
          if (!s) { return; }
          items.push({
            id: s.variantId,
            quantity: 1,
            properties: { _bundle_id: bundleId, _bundle_tier: state.tier.id, _bundle_size: sizeLabel }
          });
        });
      });
      if (addBtn) { addBtn.disabled = true; }
      if (status) { status.textContent = 'Adding…'; }
      var addUrl = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) { throw new Error((r.data && r.data.description) || 'Could not add to cart'); }
          if (status) { status.innerHTML = 'Bundle added! <a href="/cart">View cart →</a>'; }
          if (window.ACGAjaxCart && window.ACGAjaxCart.refreshCartCount) { window.ACGAjaxCart.refreshCartCount(); }
          document.dispatchEvent(new CustomEvent('acg:cart:added', { detail: { items: (r.data && r.data.items) || [] } }));
          // Reset selection for a fresh build; keep the tier active.
          state.selection = { oz32: resizeSelection([], state.tier.oz32Slots), gallon: resizeSelection([], state.tier.gallonSlots) };
          renderBuilder();
          renderSummary();
        })
        .catch(function (err) {
          if (addBtn) { addBtn.disabled = false; }
          if (status) { status.textContent = err.message || 'Something went wrong. Please try again.'; }
        });
    }

    // Event delegation
    Array.prototype.forEach.call(els.tierButtons, function (btn) {
      btn.addEventListener('click', function () { selectTier(btn.getAttribute('data-acg-bb-tier')); });
    });

    els.builder.addEventListener('click', function (e) {
      var slot = e.target.closest('[data-acg-bb-slot]');
      if (slot) { openPicker(slot.getAttribute('data-size'), parseInt(slot.getAttribute('data-index'), 10)); }
    });

    els.summary.addEventListener('click', function (e) {
      if (e.target.closest('[data-acg-bb-add]')) { addBundle(); }
    });

    els.picker.addEventListener('click', function (e) {
      if (e.target.closest('[data-acg-bb-picker-close]')) { closePicker(); return; }
      var pick = e.target.closest('[data-acg-bb-pick]');
      if (pick && !pick.disabled) { choose(pick.getAttribute('data-handle')); }
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && !els.picker.hidden) { closePicker(); }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-acg-bb]');
    Array.prototype.forEach.call(roots, initSection);
  });
})();
